import React from "react";
import { Link } from "react-router-dom";
import  {useDispatch } from "react-redux";
import { productDelete } from "../../Redux/Actions/ProductActions";
import { PICTURE_URL } from "../../api/BaseConfig";

const Product = (props) => {
  const { product } = props;
  
  const dispatch = useDispatch()
    
  const deleteHandler=(lang,id)=>{
    let result = window.confirm("Are you sure?")
    if(result){
     dispatch(productDelete(lang,id))
    }
  }
  return (
    <>
      <div className="col-md-6 col-sm-6 col-lg-3 mb-5">
        <div className="card card-product-grid shadow-sm">
          <Link to="#" className="img-wrap">
          <img src={PICTURE_URL+product.photoUrl} alt="Product" />
          </Link>
          <div className="info-wrap">
            <Link to="#" className="title text-truncate">
              {product?.productRecords?.name}
            </Link>
            <div className="price mb-2">₼{product.price}</div>
            <div className="row">
              <Link
                to={`/product/${product.id}/edit`}
                className="btn btn-sm btn-outline-success p-2 pb-3 col-md-6"
              >
                <i className="fas fa-pen"></i>
              </Link>
              <Link
                to="#"
                onClick={() => deleteHandler(product.id)}
                className="btn btn-sm btn-outline-danger p-2 pb-3 col-md-6"
              >
                <i className="fas fa-trash-alt"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Product;
